<template>
  <div class="member-handbook-page">
    <div v-html="richText"></div>
  </div>
</template>

<script>
import requestApi from '@/service';

export default {
  data() {
    return {
      richText: '',
    };
  },
  activated() {
    this.getRichText();
  },
  methods: {
    getRichText() {
      requestApi('/v3/api/site/about/', {
        type: 0,
      }).then(res => {
        this.richText = res.content;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.member-handbook-page {
  padding: 30px;
}
</style>
